// Core
import { NavigationGuard } from "vue-router";

// Libraries
import { until } from "@vueuse/core";

// Stores
import pinia from "@/store/pinia";

// Stores
import { useTeamStore } from "@/store/team";

const requireLeadMachine: NavigationGuard = async (_to, from, next) => {
  try {
    const teamStore = useTeamStore(pinia);

    if (!teamStore.currentTeam) {
      await until(() => teamStore.loading).changedTimes(2);
    }

    if (teamStore.teamHasLeadMachine) {
      next();
    } else {
      next(from);
    }
  } catch (error) {
    next({ name: "500" });
  }
};

export default requireLeadMachine;
